"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBonuses = void 0;
var next_intl_1 = require("next-intl");
var react_1 = require("react");
var currencies_1 = require("../currencies");
var geo_1 = require("../geo");
var keys_1 = require("../keys");
var useCache_1 = require("../useCache");
var useQuery_1 = require("../useQuery");
var user_1 = require("../user");
var CURRENT_LANG = 'current_lang';
var CURRENT_CURRENCY = 'current_currency';
var CURRENT_COUNTRY = 'current_country';
var useBonuses = function (currency) {
    var _a;
    var lang = (0, next_intl_1.useLocale)();
    var currentCurrency = (0, currencies_1.useCurrentCurrency)();
    var isAuth = (0, user_1.useIsAuthorized)();
    var _b = (0, useCache_1.useCache)(), getDataFromCache = _b.getDataFromCache, setDataToCache = _b.setDataToCache;
    var geoData = (0, geo_1.useGeo)().data;
    var country = (_a = geoData === null || geoData === void 0 ? void 0 : geoData.geoData) === null || _a === void 0 ? void 0 : _a.countryCode;
    var _c = (0, useQuery_1.useQuery)({
        path: keys_1.MY_BONUSES,
        payload: {
            input: {
                currency: currency,
                lang: lang,
                country: country,
            },
        },
        revalidateOnMount: true,
        canRender: !!currency && isAuth,
    }), data = _c.data, error = _c.error, isLoading = _c.isLoading, mutate = _c.mutate;
    (0, react_1.useEffect)(function () {
        var prevLang = getDataFromCache(CURRENT_LANG);
        var prevCurrency = getDataFromCache(CURRENT_CURRENCY);
        var prevCountry = getDataFromCache(CURRENT_COUNTRY);
        if (!prevCurrency ||
            prevCurrency !== currentCurrency ||
            !prevLang ||
            prevLang !== lang ||
            prevCountry !== country) {
            mutate();
            setDataToCache(CURRENT_CURRENCY, currentCurrency);
            setDataToCache(CURRENT_LANG, lang);
            setDataToCache(CURRENT_COUNTRY, country);
        }
    }, [
        getDataFromCache,
        setDataToCache,
        currentCurrency,
        mutate,
        lang,
        country,
    ]);
    return (0, react_1.useMemo)(function () { return ({
        data: (data === null || data === void 0 ? void 0 : data.data) || [],
        isLoading: isLoading,
        error: error,
    }); }, [data, isLoading, error, country]);
};
exports.useBonuses = useBonuses;
